export class Promotion {
  constructor(promotion) {
    this.id = promotion.id,
    this.campaign_id = promotion.campaign_id,
    this.code = promotion.code,
    this.customer_id = promotion.customer_id,
    this.created_at = promotion.created_at,
    this.updated_at = promotion.updated_at,
    this.is_used = promotion.is_used,
    this.expired_date = promotion.expired_date,
    this.limit_used = promotion.limit_used,
    this.total_used = promotion.total_used
  }
}
